import axios from 'axios'
import { Message } from '@supaur/element-ui-rtl'
import store from '../store'
import { getToken } from '@/utils/auth'
import { currentLang } from '@/i18n'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  withCredentials: true,
  timeout: 15000, // 请求超时时间
  headers: { 'Content-Type': 'application/json;charset=utf-8' }
})

// request拦截器
service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['X-Token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
	// 国际化请求]
	config.headers['accept-language'] = currentLang
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    Promise.resolve(response.data)
    return response.data
  },
  // {
  // /**
  // * code为非20000是抛错 可结合自己业务进行修改
  // */
  //   const res = response.data
  //   if (res.error !== 1) {
  //     Message({
  //       message: res.msg,
  //       type: 'error',
  //       duration: 5 * 1000
  //     })

  //     // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
  //     if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
  //       MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
  //         confirmButtonText: '重新登录',
  //         cancelButtonText: '取消',
  //         type: 'warning'
  //       }).then(() => {
  //         store.dispatch('FedLogOut').then(() => {
  //           location.reload()// 为了重新实例化vue-router对象 避免bug
  //         })
  //       })
  //     }
  //     return Promise.reject('error')
  //   } else {
  //     Message({
  //       message: res.msg,
  //       type: 'success',
  //       duration: 5 * 1000
  //     })
  //     return response.data
  //   }
  // },
  error => {
    Message({
      showClose: true,
      message: error.response.data.message || error.response.data.error || 'error',
      type: 'error'
    })
    return Promise.reject(error)
  }
)

const request = arg => {
  return new Promise((resolve, reject) => {
    service(arg).then(response => {
      resolve(response)
    }).catch(error => {
      reject(error)
    })
  })
}

export default request



// WEBPACK FOOTER //
// ./src/utils/request.js